
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   Paper,
//   MenuItem,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Autocomplete,
//   Checkbox,
//   FormControlLabel,
//   TextField,
// } from "@mui/material";
// import {
//   CTSinput,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import { useDispatch } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SaveIcon from "@mui/icons-material/Save";
// import { Snackbar, Alert } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import Inventory2Icon from "@mui/icons-material/Inventory2";
// import dayjs from "dayjs";
// import driverMasterService from "../../../services/masters/driverMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
// import customerMasterService from "../../../services/masters/customerMaster.Service";
// import supplierMasterService from "../../../services/masters/supplierMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import empty_delivery_challan from "../../../services/empty_delivery_challan";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import emptycolectionlistSerives from "../../../services/emptycolectionlist.Serives";

// // ── Styles ────────────────────────────────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px", color: "#718096", mb: 2,
//   display: "flex", alignItems: "center", gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex", alignItems: "center",
//   justifyContent: "space-between", mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px", fontWeight: 700, color: "#000",
//   display: "flex", alignItems: "center", gap: "10px",
// };

// const backBtnSx = {
//   display: "flex", alignItems: "center", gap: "6px",
//   fontSize: "13px", fontWeight: 600, color: "#2B6CB0",
//   padding: "7px 14px", border: "1.5px solid #2B6CB0",
//   borderRadius: "7px", background: "#fff", textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff", borderRadius: "8px",
//   boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
//   border: "1px solid #E2E8F0", overflow: "hidden", mb: 2,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E", padding: "12px 22px",
//   display: "flex", alignItems: "center", gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px", fontWeight: 600, color: "#fff", letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "20px 22px" };

// const fieldLabelSx = {
//   fontSize: "12px", fontWeight: 600, color: "#2063b6",
//   mb: "4px", display: "flex", alignItems: "center", gap: "4px",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa", height: "36px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readOnlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0F4F8",
//   },
// };

// const formFooterSx = {
//   padding: "18px 24px", background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex", alignItems: "center",
//   justifyContent: "flex-end", gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex", alignItems: "center", gap: "7px",
//   padding: "0 22px", height: "40px", background: "#4CAF50",
//   color: "#fff", border: "none", fontSize: "14px", fontWeight: 600,
//   textTransform: "none", borderRadius: "8px",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex", alignItems: "center", gap: "7px",
//   padding: "0 22px", height: "40px", background: "#E53E3E",
//   color: "#fff", border: "none", textTransform: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px", fontWeight: 600, borderRadius: "8px",
// };

// const addCylBtnSx = {
//   background: "#2B6CB0", color: "#fff", textTransform: "none",
//   borderRadius: "8px", fontSize: "13px", fontWeight: 600,
//   height: "38px", px: 2,
//   "&:hover": { background: "#1a4a8a" },
//   display: "flex", alignItems: "center", gap: "6px",
// };

// const tableHeadCellSx = {
//   background: "#1C3A5E !important", color: "#fff !important",
//   fontSize: "12px", fontWeight: 600,
//   fontFamily: "'Inter', Arial, sans-serif", whiteSpace: "nowrap",
// };

// const tableCellInputSx = {
//   "& .MuiInput-root": {
//     fontSize: "12px",
//     "&:before": { borderBottom: "none" },
//     "&:after": { borderBottom: "none" },
//     "&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
//   },
//   "& input": { fontSize: "12px", padding: "4px 6px" },
// };

// const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// // ─────────────────────────────────────────────────────────────────────────────

// const AddEmptyCollection = () => {
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;

//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;
//   const [dcType, setDcType] = useState(editData?.to_location || "");
//   const [isLocationSelected, setIsLocationSelected] = useState(!!editData?.to_location);
//   let navigate = useNavigate();

//   const [driver, setDriver] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [cylinder, setCylinder] = useState([]);
//   const [vehicle, setVehicle] = useState([]);
//   const [customer, setCustomer] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const [depot_name, setDepot_name] = useState([]);
//   const depot_id = userInfo.depot_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const [checkboxValue, setCheckboxValue] = useState(editData ? editData.update_check || 0 : 0);
//   const [showUnregisteredDriver, setShowUnregisteredDriver] = useState(!!editData?.unregistered_driver);
//   const [showUnregisteredVehicle, setShowUnregisteredVehicle] = useState(!!editData?.unregistered_vehicle);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });
// const showSuccess = (msg) => setSnack({ open: true, message: msg, severity: "success" });
// const showError = (msg) => setSnack({ open: true, message: msg, severity: "error" });

//   // ── Dialog states ──
//   const [openSearchDialog, setOpenSearchDialog] = useState(false);
//   const [openAddDialog, setOpenAddDialog] = useState(false);


//   const formatDateForAPI = (date) => {
//     if (!date) return "";
//     return dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "";
//   };

//   const [data, setData] = useState({
//     entry_no: editData ? editData.entry_no : "",
//     entry_date: editData ? formatDateForAPI(editData.entry_date) : formatDateForAPI(new Date()),
//     from_customer: editData ? editData.from_customer : "",
//     from_customer_id: editData ? editData.from_customer_id : "",
//     vehicle_no: editData ? editData.vehicle_no : "",
//     to_vehicle_id: editData ? editData.to_vehicle_id : "",
//     driver_name: editData ? editData.driver_name : "",
//     driver_id: editData ? editData.driver_id : "",
//     table_details: editData ? editData.table_details : "",
//     from_depot_id: unit_id,

//   });

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [
//           driverData, depotData, productData, customerData, vehicleData,
//           cylinderData, DdepotData, DcustomerData, supplierData,
//         ] = await Promise.all([
//           driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//           vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
//           cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//           empty_delivery_challan.getEmptyChallandepotList(depot_id),
//           empty_delivery_challan.getEmptyChallanCustomerList(depot_id),
//           supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
//         ]);

//         setDepot(DdepotData);
//         setDriver(driverData);
//         setProduct(productData);
//         setCustomer(DcustomerData);
//         setVehicle(vehicleData);
//         setCylinder(cylinderData);
//         setDepot_name(depotData);
//         setSupplier(supplierData);

//         if (!editData) {
//           const emptyList = await emptycolectionlistSerives.EmptyCylinderList({ page: 0, size: 5, searchKey: "" });
//           const lastEntryNo = emptyList?.[0]?.entry_no ?? "";
//           const parts = String(lastEntryNo).split("/");
//           const lastSeq = parseInt(parts[parts.length - 1]) || 0;
//           const nextSeq = lastSeq + 1;
//           const yr = dayjs();
//           const finYear = yr.month() >= 3
//             ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
//             : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;
//           const formattedEntryNo = `ECR/${finYear}/${String(nextSeq).padStart(4, "0")}`;
//           setData(prev => ({ ...prev, entry_no: formattedEntryNo, fin_year: finYear }));
//         }

//       } catch (error) {
//         console.error("Data fetching failed", error);
//       }
//     }
//     fetchData();
//   }, [depot_id]);

//   useEffect(() => {
//     if (editData) {
//       let to_location = editData.to_location || "";
//       if (!to_location) {
//         if (editData.to_depot_id) to_location = "depot";
//         else if (editData.to_supplier_id) to_location = "supplier";
//         else if (editData.from_customer_id) to_location = "customer";
//       }
//       setDcType(to_location);
//       setIsLocationSelected(!!to_location);
//       setData({
//         entry_no: editData.entry_no || "",
//         entry_date: formatDateForAPI(editData.entry_date),
//         from_depot: editData.from_depot || "",
//         from_depot_id: editData.from_depot_id || unit_id,
//         from_customer: editData.from_customer || "",
//         from_customer_id: editData.from_customer_id || "",
//         to_depot: editData.to_depot || "",
//         to_depot_id: editData.to_depot_id || "",
//         to_supplier: editData.to_supplier || "",
//         to_supplier_id: editData.to_supplier_id || "",
//         to_location: to_location,
//         vehicle_no: editData.vehicle_no || "",
//         vehicle_id: editData.vehicle_id || "",
//         driver_name: editData.driver_name || "",
//         driver_id: editData.driver_id || "",
//         table_details: editData.table_details || [],
    
//       });
//       if (editData.table_details) {
//         let details = editData.table_details;
//         if (typeof details === "string") {
//           try { details = JSON.parse(details); } catch (e) { details = []; }
//         }
//         const processedDetails = details.map((row, index) => {
//           let prodId = row.prod_id || "";
//           if (!prodId && row.prod_code && product.length > 0) {
//             const matchingProduct = product.find((p) => p.prod_code === row.prod_code);
//             prodId = matchingProduct ? matchingProduct.prod_id : "";
//           }
//           return {
//             sr_no: index + 1, cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "",
//             prod_code: row.prod_code || "", prod_id: prodId, type: row.type || "Empty",
//             tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "",
//             level: row.level ?? row.note ?? "", note: row.level ?? row.note ?? ""
//           };
//         });
//         settable_details(processedDetails);
//       }
//     }
//   }, [editData, depot, customer, supplier, unit_id, product]);

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     let updatedFields = { [name]: value };
//     if (name === "entry_date") {
//       updatedFields.entry_date = formatDateForAPI(value);
//       const selectedDate = dayjs(value);
//       if (selectedDate.isValid()) {
//         const month = selectedDate.month(), year = selectedDate.year();
//         updatedFields.fin_year = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
//       }
//     } else if (name === "from_customer_id") {
//       const sel = customer.find((c) => c.cust_id === value);
//       updatedFields.from_customer = sel ? sel.cust_name : "";
//       emptycolectionlistSerives
//         .getCustomerCylinder(value)
//         .then((res) => { setCylinder(Array.isArray(res) ? res : []); })
//         .catch(() => { setCylinder([]); });
//     } else if (name === "driver_id") {
//       const sel = driver.find((d) => d.driver_id === value);
//       updatedFields.driver_name = sel ? sel.driver_name : "";
//     } else if (name === "vehicle_id") {
//       const sel = vehicle.find((v) => v.vehicle_id === value);
//       updatedFields.vehicle_no = sel ? sel.vehicle_no : "";
//     }
//     setData((prevData) => ({ ...prevData, ...updatedFields }));
//   };

//   const [table_details, settable_details] = useState(() => {
//     if (editData && editData.table_details) {
//       try {
//         const parsedDetails = JSON.parse(editData.table_details);
//         return parsedDetails.map((row, index) => ({
//           sr_no: index + 1, cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "",
//           prod_code: row.prod_code || "", prod_id: row.prod_id || "", type: row.type || "Empty",
//           tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "",
//           level: row.level ?? row.note ?? "", note: row.level ?? row.note ?? ""
//         }));
//       } catch (error) { return []; }
//     }
//     return [];
//   });

// const availableCylinders = React.useMemo(
//   () => cylinder.filter((c) => !table_details.some((row) => row.cyl_no === c.cylinder_no)),
//   [cylinder, table_details]
// );

//   const getProdIdByCode = (prodCode) => {
//     if (!prodCode || product.length === 0) return "";
//     const matchingProduct = product.find((p) => p.prod_code === prodCode);
//     return matchingProduct ? matchingProduct.prod_id : "";
//   };

//   const handleChangeInput = (e, index) => {
//     const { name, value } = e.target;
//     const updatedArray = [...table_details];
//     const row = updatedArray[index];
//     if (name === "cyl_no") {
//       row.cyl_no = value;
//       const selectedCyl = cylinder.find((c) => c.cylinder_no === value);
//       if (selectedCyl) {
//         row.cyl_id = selectedCyl.cyl_id || "";
//         row.prod_code = selectedCyl.prod_code || "";
//         row.prod_id = getProdIdByCode(selectedCyl.prod_code);
//         row.tag_no = selectedCyl.tag_no || "";
//         row.owner = selectedCyl.owner || "";
//         row.note = "";
//       } else {
//         row.cyl_id = ""; row.prod_code = ""; row.prod_id = ""; row.tag_no = ""; row.owner = ""; row.note = "";
//       }
//     } else { row[name] = value; }
//     updatedArray[index] = row;
//     settable_details(updatedArray);
//   };

//   const onSubmit = async (event) => {
//     event.preventDefault();
//     const cylinders = table_details.map((row) => ({
//       sr_no: row.sr_no, cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "",
//       tag_no: row.tag_no || "", owner: row.owner || "", prod_code: row.prod_code || "",
//       prod_id: row.prod_id || "", type: row.type || "Empty", remark: row.remark || "",
//       level: row.level ?? row.note ?? "", note: row.level ?? row.note ?? ""
//     }));
//     const dcData = {
//       entryDate: formatDateForAPI(data.entry_date) || formatDateForAPI(new Date()),
//       from_customer_id: data.from_customer_id || null,
//       to_depot_id: data.to_depot_id || null,
//       to_supplier_id: data.to_supplier_id || null,
     
   
// driver_name: data.driver_name || data.unregistered_driver || '',
// vehicle_no: data.vehicle_no || data.unregistered_vehicle || '',
// created_by: editData ? String(editData.created_by) : String(userInfo.user_id),
//       short_code: short_code || "",
//       fin_year: data.fin_year || (dayjs(data.entry_date).month() >= 3
//         ? `${dayjs(data.entry_date).year()}-${dayjs(data.entry_date).year() + 1}`
//         : `${dayjs(data.entry_date).year() - 1}-${dayjs(data.entry_date).year()}`),
//       cylinders,
   
//       to_location: dcType || null,
//     };
//     try {
//       if (editData) {
//         await emptycolectionlistSerives.editDeleteEmptyCollection(dcData);
//          showSuccess("Updated successfully")
//       } else {
//         await emptycolectionlistSerives.addEmptyCylinder(dcData);
//       showSuccess("Added successfully")
//       }
//       setTimeout(() => navigate(-1), 1000);
//     } catch (error) {
//      showError(`Error occurred during submission: ${error.message}`);
//     }
//   };

//   // ── Search Dialog ──
// const [formData, setFormData] = useState({ cyl_no: "", cyl_id: "", tag_no: "",  owner: "TGPL", prod_id: "", prod_code: "DA001", type: "Empty", note: "" });

//   const handleOpenSearchDialog = () => setOpenSearchDialog(true);
//   const handleCloseSearchDialog = () => {
//     setOpenSearchDialog(false);
//    setFormData({ cyl_no: "", cyl_id: "", tag_no: "",  owner: "TGPL", prod_id: "", prod_code: "DA001", type: "Empty", note: "" });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

// const handleCylinderSelect = (event, newValue) => {
//   if (newValue && typeof newValue === "object") {
//     setFormData((prev) => ({
//       ...prev, cyl_no: newValue.cylinder_no || "", cyl_id: newValue.cyl_id || "",
//       tag_no: newValue.tag_no || "", owner: newValue.owner || "",
//       // Product Code hamesha DA001 (ya jo pehle se select tha) rehna chahiye,
//       // cylinder ke apne prod_code se overwrite nahi karna
//       prod_code: prev.prod_code || "DA001", prod_id: prev.prod_id,
//       type: newValue.status || "Empty", note: ""
//     }));
//   } else if (typeof newValue === "string") {
//     // Naya cylinder type kiya — cyl_id blank, baaki fields user bharega
//     setFormData((prev) => ({ ...prev, cyl_no: newValue, cyl_id: "", tag_no: "", owner: "", prod_code: prev.prod_code || "DA001", prod_id: prev.prod_id }));
//   } else {
//     setFormData((prev) => ({ ...prev, cyl_no: "", cyl_id: "", tag_no: "", owner: "", prod_code: prev.prod_code || "DA001", prod_id: prev.prod_id, type: "Empty", note: "" }));
//   }
// };

// const handleSearchSubmit = async () => {
//   if (!formData.cyl_no) return;

//   if (!formData.cyl_id) {
//     // Naya cylinder — API se save karke add karo
//     if (!formData.tag_no || !formData.owner) {
//      showError("Please fill Tag No and Owner for the new cylinder");
//       return;
//     }
//     try {
//       const res = await emptycolectionlistSerives.addNewCylinder({
//         cyl_no: formData.cyl_no,
//         tag_no: formData.tag_no,
//         owner: formData.owner,
//         prod_code: formData.prod_code || "",
//         prod_id: formData.prod_id || null,
//         type: formData.type,
//         note: formData.note || null,
//         created_by: String(userInfo.user_id),
//       });
//       settable_details((prev) => [...prev, {
//         sr_no: prev.length + 1, cyl_no: formData.cyl_no,
//         cyl_id: res.id || "", tag_no: formData.tag_no,
//         owner: formData.owner, prod_code: formData.prod_code,
//         prod_id: formData.prod_id, type: formData.type,
//         remark: "", note: formData.note || ""
//       }]);
//       showSuccess("Cylinder added successfully");
//       handleCloseSearchDialog();
//     } catch (error) {
//       showError(error.message);
//     }
//     return;
//   }

//   // Existing cylinder
//   settable_details((prev) => [...prev, {
//     sr_no: prev.length + 1, cyl_no: formData.cyl_no, cyl_id: formData.cyl_id,
//     tag_no: formData.tag_no, owner: formData.owner, prod_code: formData.prod_code,
//     prod_id: formData.prod_id, type: formData.type, remark: "", note: formData.note || ""
//   }]);
//   handleCloseSearchDialog();
// };

//   // ── Add Cylinder Dialog ──
//   const [addFormData, setAddFormData] = useState({
//     cyl_no: "", tag_no: "", owner: "", prod_code: "", prod_id: "", type: "Empty", note: ""
//   });

//   const handleOpenAddDialog = () => setOpenAddDialog(true);
//   const handleCloseAddDialog = () => {
//     setOpenAddDialog(false);
//     setAddFormData({ cyl_no: "", tag_no: "", owner: "", prod_code: "", prod_id: "", type: "Empty", note: "" });
//   };

//   const handleAddInputChange = (e) => {
//     const { name, value } = e.target;
//     setAddFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleAddCylinderSubmit = async () => {
//       console.log('addFormData:', addFormData); // ✅ add karo
//     if (!addFormData.cyl_no || !addFormData.tag_no || !addFormData.owner || !addFormData.type) {
// showError("Cylinder No, Tag No, Owner and Status are required");
//       return;
//     }
//     try {
//        console.log('API call ho rahi hai...');
//       const res = await emptycolectionlistSerives.addNewCylinder({
//         cyl_no: addFormData.cyl_no,
//         tag_no: addFormData.tag_no,
//         owner: addFormData.owner,
//         prod_code: addFormData.prod_code,
//         prod_id: addFormData.prod_id || null,
//         type: addFormData.type,
//         note: addFormData.note || null,
//         created_by: String(userInfo.user_id),
//       });
//       settable_details((prev) => [...prev, {
//         sr_no: prev.length + 1, cyl_no: addFormData.cyl_no,
//         cyl_id: res.id || "", tag_no: addFormData.tag_no,
//         owner: addFormData.owner, prod_code: addFormData.prod_code,
//         prod_id: addFormData.prod_id, type: addFormData.type,
//         remark: "", note: addFormData.note || ""
//       }]);
//   //  showSuccess("Cylinder added successfully");
//       handleCloseAddDialog();
//     } catch (error) {
//         console.log('error:', error.message);
//        showError(error.message);
//     }
//   };

//   const handleRemoveCylinder = (index) => {
//     const updatedArray = table_details.filter((_, i) => i !== index);
//     settable_details(updatedArray.map((row, i) => ({ ...row, sr_no: i + 1 })));
//   };

//   const handleCheckboxChange = (event) => {
//     setCheckboxValue(event.target.checked ? 1 : 0);
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>

//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Collection</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <Inventory2Icon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} EMPTY COLLECTION
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         <form onSubmit={onSubmit}>

//           {/* ── Section 1: Collection Details ── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <Inventory2Icon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Collection Details</Typography>
//             </Box>

//             <Box sx={formBodySx}>
//               <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//                 {/* LEFT COLUMN */}
//                 <Grid item xs={12} md={6} sx={{ p: 2.5, borderBottom: { xs: "2px dashed #CBD5E0", md: "none" } }}>
//                   <Grid container spacing={1.5}>

//                     {/* Customer */}
//                     <Grid item xs={12} sm={5}>
//                       <Typography sx={fieldLabelSx}>Customer</Typography>
//                       <Autocomplete
//                         disablePortal options={customer || []}
//                         getOptionLabel={(option) => option.cust_name || ""}
//                         value={customer.find((c) => c.cust_id === data.from_customer_id) || null}
//                         onChange={(event, newValue) => {
//                           handleChange({ target: { name: "from_customer_id", value: newValue ? newValue.cust_id : "" } });
//                         }}
//                         isOptionEqualToValue={(option, value) => option.cust_id === value.cust_id}
//                         renderOption={(props, option) => (
//                           <MenuItem {...props} sx={menuItemSx}>{option.cust_name}</MenuItem>
//                         )}
//                         renderInput={(params) => (
//                           <TextField {...params} variant="outlined" size="small" fullWidth
//                             InputProps={{ ...params.InputProps, sx: { height: "36px" } }}
//                             sx={inputSx}
//                           />
//                         )}
//                         sx={{ width: "100%" }}
//                       />
//                     </Grid>

//                     {/* Driver Name */}
//                    <Grid item xs={12} sm={5}>
//   <Typography sx={fieldLabelSx}>Driver Name</Typography>
//   <Autocomplete
//     freeSolo
//     disablePortal
//     options={driver || []}
//     getOptionLabel={(option) =>
//       typeof option === "string" ? option : option.driver_name || ""
//     }
//     value={
//       driver.find((d) => d.driver_id === data.driver_id) ||
//       data.unregistered_driver ||
//       null
//     }
//     onChange={(event, newValue) => {
//       if (newValue && typeof newValue === "object") {
//         handleChange({ target: { name: "driver_id", value: newValue.driver_id } });
//         handleChange({ target: { name: "driver_name", value: newValue.driver_name } });
//         handleChange({ target: { name: "unregistered_driver", value: "" } });
//       } else if (typeof newValue === "string") {
//         handleChange({ target: { name: "driver_id", value: "" } });
//         handleChange({ target: { name: "driver_name", value: newValue } });
//         handleChange({ target: { name: "unregistered_driver", value: newValue } });
//       } else {
//         handleChange({ target: { name: "driver_id", value: "" } });
//         handleChange({ target: { name: "driver_name", value: "" } });
//         handleChange({ target: { name: "unregistered_driver", value: "" } });
//       }
//     }}
//     onInputChange={(event, inputValue, reason) => {
//       if (reason === "input") {
//         const matched = driver.find(
//           (d) => d.driver_name?.toLowerCase() === inputValue?.toLowerCase()
//         );
//         if (!matched) {
//           handleChange({ target: { name: "driver_id", value: "" } });
//           handleChange({ target: { name: "driver_name", value: inputValue } });
//           handleChange({ target: { name: "unregistered_driver", value: inputValue } });
//         }
//       }
//     }}
//     renderOption={(props, option) => (
//       <MenuItem {...props} sx={menuItemSx}>{option.driver_name}</MenuItem>
//     )}
//     renderInput={(params) => (
//       <TextField
//         {...params}
//         variant="outlined"
//         size="small"
//         fullWidth
//         placeholder="Select or type driver name"
//         InputProps={{ ...params.InputProps, sx: { height: "36px" } }}
//         sx={inputSx}
//       />
//     )}
//     sx={{ width: "100%" }}
//   />
// </Grid>

//                     {/* Vehicle No */}
//                   <Grid item xs={12} sm={5}>
//   <Typography sx={fieldLabelSx}>Vehicle No</Typography>
//   <Autocomplete
//     freeSolo
//     disablePortal
//     options={vehicle || []}
//     getOptionLabel={(option) =>
//       typeof option === "string" ? option : option.vehicle_no || ""
//     }
//     value={
//       vehicle.find((v) => v.vehicle_id === data.vehicle_id) ||
//       data.unregistered_vehicle ||
//       null
//     }
//     onChange={(event, newValue) => {
//       if (newValue && typeof newValue === "object") {
//         handleChange({ target: { name: "vehicle_id", value: newValue.vehicle_id } });
//         handleChange({ target: { name: "vehicle_no", value: newValue.vehicle_no } });
//         handleChange({ target: { name: "unregistered_vehicle", value: "" } });
//       } else if (typeof newValue === "string") {
//         handleChange({ target: { name: "vehicle_id", value: "" } });
//         handleChange({ target: { name: "vehicle_no", value: newValue } });
//         handleChange({ target: { name: "unregistered_vehicle", value: newValue } });
//       } else {
//         handleChange({ target: { name: "vehicle_id", value: "" } });
//         handleChange({ target: { name: "vehicle_no", value: "" } });
//         handleChange({ target: { name: "unregistered_vehicle", value: "" } });
//       }
//     }}
//     onInputChange={(event, inputValue, reason) => {
//       if (reason === "input") {
//         const matched = vehicle.find(
//           (v) => v.vehicle_no?.toLowerCase() === inputValue?.toLowerCase()
//         );
//         if (!matched) {
//           handleChange({ target: { name: "vehicle_id", value: "" } });
//           handleChange({ target: { name: "vehicle_no", value: inputValue } });
//           handleChange({ target: { name: "unregistered_vehicle", value: inputValue } });
//         }
//       }
//     }}
//     renderOption={(props, option) => (
//       <MenuItem {...props} sx={menuItemSx}>{option.vehicle_no}</MenuItem>
//     )}
//     renderInput={(params) => (
//       <TextField
//         {...params}
//         variant="outlined"
//         size="small"
//         fullWidth
//         placeholder="Select or type vehicle no"
//         InputProps={{ ...params.InputProps, sx: { height: "36px" } }}
//         sx={inputSx}
//       />
//     )}
//     sx={{ width: "100%" }}
//   />
// </Grid>


//   <Grid item xs={12} sm={5}>
//                 <Typography sx={fieldLabelSx}>Product Code</Typography>
//                 <TextField select name="prod_code" value={formData.prod_code || "DA001"} onChange={handleInputChange}
//                   variant="outlined" size="small" fullWidth sx={inputSx}>
//                   {product.map((p) => (
//                     <MenuItem key={p.prod_id} value={p.prod_code} sx={menuItemSx}>{p.prod_code}</MenuItem>
//                   ))}
//                 </TextField>
//               </Grid>

//                   </Grid>
//                 </Grid>

//                 {/* RIGHT COLUMN */}
//                 <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
//                   <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0 }}>
//                     <Box sx={{ flex: 1 }}>
//                       <Typography sx={fieldLabelSx}>Entry No</Typography>
//                       <TextField
//                         size="small" fullWidth name="entry_no" value={data.entry_no}
//                         sx={readOnlyInputSx} InputProps={{ readOnly: true }}
//                         placeholder="Auto-generated"
//                       />
//                     </Box>
//                     <Box sx={{ mx: 2, mt: "22px" }} />
//                     <Box sx={{ flex: 1 }}>
//                       <Typography sx={fieldLabelSx}>
//                         Entry Date <span style={{ color: "#E53E3E" }}>*</span>
//                       </Typography>
//                       <DatePicker
//                         format="DD/MM/YYYY"
//                         value={data.entry_date ? dayjs(data.entry_date) : null}
//                         onChange={(newValue) =>
//                           handleChange({ target: { name: "entry_date", value: newValue ? newValue.toDate() : "" } })
//                         }
//                         slotProps={{
//                           textField: { size: "small", fullWidth: true, required: true, sx: inputSx },
//                         }}
//                       />
//                     </Box>
//                   </Box>
//                 </Grid>

//               </Grid>
//             </Box>
//           </Box>

//           {/* ── Buttons Row ── */}
//           <Box sx={{ display: "flex", gap: 2, mb: 1.5 }}>
//             <Button onClick={handleOpenSearchDialog} sx={addCylBtnSx}>
//               <AddIcon sx={{ fontSize: 18 }} />
//               Add / Search Cylinders
//             </Button>
//             {/* <Button onClick={handleOpenAddDialog} sx={{ ...addCylBtnSx, background: "#276749", "&:hover": { background: "#1e4f36" } }}>
//               <AddIcon sx={{ fontSize: 18 }} />
//               Add Cylinder
//             </Button> */}
//           </Box>

//           {/* ── Section 2: Cylinder Details Table ── */}
//           <Box sx={formCardSx}>
//             <Paper sx={{ width: "100%", boxShadow: "none" }}>
//               <TableContainer component={Paper} sx={{ boxShadow: "none", borderRadius: 0 }}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <StyledTableRow>
//                       {["Sr No", "Cylinder No", "Tag No", "Owner","Status", "Remark",   "Action"].map((h, i) => (
//                         <StyledTableCell key={i} align={i === 0 ? "center" : "left"} sx={tableHeadCellSx}>{h}</StyledTableCell>
//                       ))}
//                     </StyledTableRow>
//                   </TableHead>
//                   <TableBody sx={{ backgroundColor: "#fff" }}>
//                     {table_details && table_details.length > 0 ? (
//                       table_details.map((row, index) => (
//                         <StyledTableRow key={index} sx={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC" }}>
//                           <StyledTableCell align="center" sx={{ fontSize: "12px" }}>{row.sr_no}</StyledTableCell>
//                           {["cyl_no", "tag_no", "owner",  "type", "note"].map((name) => (
//                             <StyledTableCell key={name} align="left">
//                               <CTSinput fullWidth size="small" variant="standard" name={name}
//                                 value={row[name]}
//                                 onChange={(e) => handleChangeInput(e, index)}
//                                 sx={tableCellInputSx}
//                                 InputProps={{
//                                   disableUnderline: true,
//                                   readOnly: name === "prod_code" || name === "type",
//                                   style: { border: "none", backgroundColor: "transparent", boxShadow: "none" }
//                                 }}
//                               />
//                             </StyledTableCell>
//                           ))}
//                           <StyledTableCell align="center">
//                             <IconButton size="small" onClick={() => handleRemoveCylinder(index)}>
//                               <DeleteForeverIcon sx={{ fontSize: "18px", color: "#E53E3E" }} />
//                             </IconButton>
//                           </StyledTableCell>
//                         </StyledTableRow>
//                       ))
//                     ) : (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={8} align="center" sx={{ color: "#718096", py: 3, fontSize: "12px" }}>
//                           No cylinders selected — click "Search Cylinders" or "Add Cylinder" to add
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Paper>

//             {editData && (
//               <Box sx={{ px: 3, pt: 2 }}>
//                 <FormControlLabel
//                   control={<Checkbox checked={checkboxValue === 1} onChange={handleCheckboxChange} color="primary" sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} />}
//                   label={<Typography sx={{ fontSize: "13px", fontWeight: 600 }}>Confirm Status Update</Typography>}
//                 />
//               </Box>
//             )}

//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>

//         </form>

//         {/* ── Search Cylinder Dialog ── */}
//         <Dialog open={openSearchDialog} onClose={handleCloseSearchDialog} maxWidth="lg" fullWidth
//           PaperProps={{ sx: { borderRadius: "14px", height: "400px", width:'800px' } }}>
//           <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontSize: "14px", fontWeight: 700, py: 1.5 }}>
//            Add / Search Cylinders
//           </DialogTitle>
//           <DialogContent sx={{ pt: 2 }}>
//             <Grid container spacing={2} sx={{ mt: 0.5 }}>
//               <Grid item xs={12} sm={6} md={2.4}>
//                 <Typography sx={fieldLabelSx}>Cylinder No</Typography>
//              <Autocomplete freeSolo disablePortal options={availableCylinders || []}
//   getOptionLabel={(option) => typeof option === "string" ? option : option.cylinder_no || ""}
//   value={cylinder.find((c) => c.cylinder_no === formData.cyl_no) || formData.cyl_no || null}
//   onChange={handleCylinderSelect}
//   onInputChange={(event, inputValue, reason) => {
//     if (reason === "input" && inputValue) {
//       const matched = cylinder.find((c) => c.cylinder_no === inputValue);
//       if (!matched) setFormData(prev => ({ ...prev, cyl_no: inputValue, cyl_id: "", tag_no: "", owner: prev.owner || "TGPL" }));
//     }
//   }}
//   renderOption={(props, option) => (
//     <MenuItem {...props} sx={menuItemSx}>{option.cylinder_no}</MenuItem>
//   )}
//   renderInput={(params) => (
//     <TextField {...params} variant="outlined" size="small" fullWidth sx={inputSx} />
//   )}
// />
//               </Grid>
//               <Grid item xs={12} sm={6} md={2.4}>
//                 <Typography sx={fieldLabelSx}>Tag No</Typography>
//                 <TextField name="tag_no" value={formData.tag_no} onChange={handleInputChange}
//                   variant="outlined" size="small" fullWidth sx={inputSx} InputProps={{ readOnly: !!formData.cyl_id }} />
//               </Grid>
//              <Grid item xs={12} sm={6} md={2.4}>
//                 <Typography sx={fieldLabelSx}>Owner</Typography>
//                 <TextField select name="owner" value={formData.owner} onChange={handleInputChange} variant="outlined" size="small" fullWidth sx={inputSx}>
//                   <MenuItem value="TGPL" sx={menuItemSx}>TGPL</MenuItem>
//                   <MenuItem value="CUSTOMER" sx={menuItemSx}>CUSTOMER</MenuItem>
//                 </TextField>
//               </Grid>
//               {/* <Grid item xs={12} sm={6} md={2.4}>
//                 <Typography sx={fieldLabelSx}>Product Code</Typography>
//                 <TextField name="prod_code" value={formData.prod_code} onChange={handleInputChange}
//                   variant="outlined" size="small" fullWidth sx={readOnlyInputSx} InputProps={{ readOnly: true }} />
//               </Grid> */}
//               <Grid item xs={12} sm={6} md={2.4}>
//                 <Typography sx={fieldLabelSx}>Status</Typography>
//                 <TextField select name="type" value={formData.type} onChange={handleInputChange}
//                   variant="outlined" size="small" fullWidth sx={inputSx}>
//                   <MenuItem value="Empty" sx={menuItemSx}>Empty</MenuItem>
//                   <MenuItem value="Full" sx={menuItemSx}>Full</MenuItem>
//                 </TextField>
//               </Grid>
//               {formData.type === "Full" && (
//                 <Grid item xs={12} sm={6} md={2.4}>
//                   <Typography sx={fieldLabelSx}>Remark</Typography>
//                   <TextField select name="note" value={formData.note} onChange={handleInputChange}
//                     variant="outlined" size="small" fullWidth sx={inputSx}>
//                     <MenuItem value="TOPUP" sx={menuItemSx}>TOPUP</MenuItem>
//                     <MenuItem value="SALESRETURN" sx={menuItemSx}>SALES RETURN</MenuItem>
//                     <MenuItem value="REJECTION" sx={menuItemSx}>REJECTION</MenuItem>
//                     <MenuItem value="LEAKAGE" sx={menuItemSx}>LEAKAGE</MenuItem>
//                   </TextField>
//                 </Grid>
//               )}
//             </Grid>
//           </DialogContent>
//           <DialogActions sx={{ px: 3, py: 2 }}>
//             <Button onClick={handleCloseSearchDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleSearchSubmit} sx={saveBtnSx}>
//               <SaveIcon sx={{ fontSize: 16 }} /> OK
//             </Button>
//           </DialogActions>
//         </Dialog>

//         {/* ── Add Cylinder Dialog ── */}
//         {/* <Dialog open={openAddDialog} onClose={handleCloseAddDialog} maxWidth="md" fullWidth
//           PaperProps={{ sx: { borderRadius: "14px" } }}>
//           <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontSize: "14px", fontWeight: 700, py: 1.5 ,}}>
//             Add New Cylinder
//           </DialogTitle>
//           <DialogContent sx={{ pt: 2,width:800, }}>
//             <Grid container spacing={2} sx={{ mt: 0.5 }}>
//               <Grid item xs={12} sm={6} md={3}>
//                 <Typography sx={fieldLabelSx}>Cylinder No <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                 <TextField name="cyl_no" value={addFormData.cyl_no} onChange={handleAddInputChange}
//                   variant="outlined" size="small" fullWidth sx={inputSx} />
//               </Grid>
//               <Grid item xs={12} sm={6} md={3}>
//                 <Typography sx={fieldLabelSx}>Tag No <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                 <TextField name="tag_no" value={addFormData.tag_no} onChange={handleAddInputChange}
//                   variant="outlined" size="small" fullWidth sx={inputSx} />
//               </Grid>
//               <Grid item xs={12} sm={6} md={3}>
//                 <Typography sx={fieldLabelSx}>Owner <span style={{ color: "#E53E3E" }}>*</span></Typography>
//               <TextField select name="owner" value={addFormData.owner} onChange={handleAddInputChange}
//   variant="outlined" size="small" fullWidth sx={inputSx}>
//   <MenuItem value="TGPL" sx={menuItemSx}>TGPL</MenuItem>
//   <MenuItem value="Customer" sx={menuItemSx}>Customer</MenuItem>
// </TextField>
//               </Grid>
             
//               <Grid item xs={12} sm={6} md={3}>
//                 <Typography sx={fieldLabelSx}>Status <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                 <TextField select name="type" value={addFormData.type} onChange={handleAddInputChange}
//                   variant="outlined" size="small" fullWidth sx={inputSx}>
//                   <MenuItem value="Empty" sx={menuItemSx}>Empty</MenuItem>
//                   <MenuItem value="Full" sx={menuItemSx}>Full</MenuItem>
//                 </TextField>
//               </Grid>
//               {addFormData.type === "Full" && (
//                 <Grid item xs={12} sm={6} md={3}>
//                   <Typography sx={fieldLabelSx}>Remark</Typography>
//                   <TextField select name="note" value={addFormData.note} onChange={handleAddInputChange}
//                     variant="outlined" size="small" fullWidth sx={inputSx}>
//                     <MenuItem value="TOPUP" sx={menuItemSx}>TOPUP</MenuItem>
//                     <MenuItem value="SALESRETURN" sx={menuItemSx}>SALES RETURN</MenuItem>
//                     <MenuItem value="REJECTION" sx={menuItemSx}>REJECTION</MenuItem>
//                     <MenuItem value="LEAKAGE" sx={menuItemSx}>LEAKAGE</MenuItem>
//                   </TextField>
//                 </Grid>
//               )}
//             </Grid>
//           </DialogContent>
//           <DialogActions sx={{ px: 3, py: 2 }}>
//             <Button onClick={handleCloseAddDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleAddCylinderSubmit} sx={saveBtnSx}>
//               <SaveIcon sx={{ fontSize: 16 }} /> Save
//             </Button>
//           </DialogActions>
//         </Dialog> */}

//      <Snackbar
//   open={snack.open}
//   autoHideDuration={3000}
//   onClose={() => setSnack({ ...snack, open: false })}
//   anchorOrigin={{ vertical: "top", horizontal: "right" }}
// >
//   <Alert
//     onClose={() => setSnack({ ...snack, open: false })}
//     severity={snack.severity}
    
//     sx={{ width: "100%" }}
//   >
//     {snack.message}
//   </Alert>
// </Snackbar>
        
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default AddEmptyCollection;

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  MenuItem,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import {
  CTSinput,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import { Snackbar, Alert } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import dayjs from "dayjs";
import driverMasterService from "../../../services/masters/driverMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import productMasterService from "../../../services/masters/productMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import supplierMasterService from "../../../services/masters/supplierMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import empty_delivery_challan from "../../../services/empty_delivery_challan";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import emptycolectionlistSerives from "../../../services/emptycolectionlist.Serives";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";

// ── Styles ────────────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px", color: "#718096", mb: 2,
  display: "flex", alignItems: "center", gap: "6px",
};

const pageHeaderSx = {
  display: "flex", alignItems: "center",
  justifyContent: "space-between", mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px", fontWeight: 700, color: "#000",
  display: "flex", alignItems: "center", gap: "10px",
};

const backBtnSx = {
  display: "flex", alignItems: "center", gap: "6px",
  fontSize: "13px", fontWeight: 600, color: "#2B6CB0",
  padding: "7px 14px", border: "1.5px solid #2B6CB0",
  borderRadius: "7px", background: "#fff", textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff", borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  border: "1px solid #E2E8F0", overflow: "hidden", mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E", padding: "12px 22px",
  display: "flex", alignItems: "center", gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px", fontWeight: 600, color: "#fff", letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px", fontWeight: 600, color: "#2063b6",
  mb: "4px", display: "flex", alignItems: "center", gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa", height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readOnlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const formFooterSx = {
  padding: "18px 24px", background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex", alignItems: "center",
  justifyContent: "flex-end", gap: "10px",
};

const saveBtnSx = {
  display: "flex", alignItems: "center", gap: "7px",
  padding: "0 22px", height: "40px", background: "#4CAF50",
  color: "#fff", border: "none", fontSize: "14px", fontWeight: 600,
  textTransform: "none", borderRadius: "8px",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex", alignItems: "center", gap: "7px",
  padding: "0 22px", height: "40px", background: "#E53E3E",
  color: "#fff", border: "none", textTransform: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px", fontWeight: 600, borderRadius: "8px",
};

const addCylBtnSx = {
  background: "#2B6CB0", color: "#fff", textTransform: "none",
  borderRadius: "8px", fontSize: "13px", fontWeight: 600,
  height: "38px", px: 2,
  "&:hover": { background: "#1a4a8a" },
  display: "flex", alignItems: "center", gap: "6px",
};

const tableHeadCellSx = {
  background: "#1C3A5E !important", color: "#fff !important",
  fontSize: "12px", fontWeight: 600,
  fontFamily: "'Inter', Arial, sans-serif", whiteSpace: "nowrap",
};

const tableCellInputSx = {
  "& .MuiInput-root": {
    fontSize: "12px",
    "&:before": { borderBottom: "none" },
    "&:after": { borderBottom: "none" },
    "&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
  },
  "& input": { fontSize: "12px", padding: "4px 6px" },
};

const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// ─────────────────────────────────────────────────────────────────────────────

const AddEmptyCollection = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const [dcType, setDcType] = useState(editData?.to_location || "");
  const [isLocationSelected, setIsLocationSelected] = useState(!!editData?.to_location);
  let navigate = useNavigate();

  const [driver, setDriver] = useState([]);
  const [depot, setDepot] = useState([]);
  const [product, setProduct] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [depot_name, setDepot_name] = useState([]);
  const depot_id = userInfo.depot_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const [checkboxValue, setCheckboxValue] = useState(editData ? editData.update_check || 0 : 0);
  const [showUnregisteredDriver, setShowUnregisteredDriver] = useState(!!editData?.unregistered_driver);
  const [showUnregisteredVehicle, setShowUnregisteredVehicle] = useState(!!editData?.unregistered_vehicle);
  const [successMessage, setSuccessMessage] = useState(null);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });
const showSuccess = (msg) => setSnack({ open: true, message: msg, severity: "success" });
const showError = (msg) => setSnack({ open: true, message: msg, severity: "error" });

  // ── Dialog states ──
  const [openSearchDialog, setOpenSearchDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);


  const formatDateForAPI = (date) => {
    if (!date) return "";
    return dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "";
  };

  const [data, setData] = useState({
    entry_no: editData ? editData.entry_no : "",
    entry_date: editData ? formatDateForAPI(editData.entry_date) : formatDateForAPI(new Date()),
    from_customer: editData ? editData.from_customer : "",
    from_customer_id: editData ? editData.from_customer_id : "",
    vehicle_no: editData ? editData.vehicle_no : "",
    to_vehicle_id: editData ? editData.to_vehicle_id : "",
    driver_name: editData ? editData.driver_name : "",
    driver_id: editData ? editData.driver_id : "",
    table_details: editData ? editData.table_details : "",
    from_depot_id: unit_id,

  });

  useEffect(() => {
    async function fetchData() {
      try {
        const [
          driverData, depotData, productData, customerData, vehicleData,
          cylinderData, DdepotData, DcustomerData, supplierData,
        ] = await Promise.all([
          driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
          productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
          customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
          vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
          cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
          empty_delivery_challan.getEmptyChallandepotList(depot_id),
          empty_delivery_challan.getEmptyChallanCustomerList(depot_id),
          supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
        ]);

        setDepot(DdepotData);
        setDriver(driverData);
        setProduct(productData);
        setCustomer(DcustomerData);
        setVehicle(vehicleData);
        setCylinder(cylinderData);
        setDepot_name(depotData);
        setSupplier(supplierData);

        if (!editData) {
          const emptyList = await emptycolectionlistSerives.EmptyCylinderList({ page: 0, size: 5, searchKey: "" });
          const lastEntryNo = emptyList?.[0]?.entry_no ?? "";
          const parts = String(lastEntryNo).split("/");
          const lastSeq = parseInt(parts[parts.length - 1]) || 0;
          const nextSeq = lastSeq + 1;
          const yr = dayjs();
          const finYear = yr.month() >= 3
            ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
            : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;
          const formattedEntryNo = `ECR/${finYear}/${String(nextSeq).padStart(4, "0")}`;
          setData(prev => ({ ...prev, entry_no: formattedEntryNo, fin_year: finYear }));
        }

      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }
    fetchData();
  }, [depot_id]);

  useEffect(() => {
    if (editData) {
      let to_location = editData.to_location || "";
      if (!to_location) {
        if (editData.to_depot_id) to_location = "depot";
        else if (editData.to_supplier_id) to_location = "supplier";
        else if (editData.from_customer_id) to_location = "customer";
      }
      setDcType(to_location);
      setIsLocationSelected(!!to_location);
      setData({
        entry_no: editData.entry_no || "",
        entry_date: formatDateForAPI(editData.entry_date),
        from_depot: editData.from_depot || "",
        from_depot_id: editData.from_depot_id || unit_id,
        from_customer: editData.from_customer || "",
        from_customer_id: editData.from_customer_id || "",
        to_depot: editData.to_depot || "",
        to_depot_id: editData.to_depot_id || "",
        to_supplier: editData.to_supplier || "",
        to_supplier_id: editData.to_supplier_id || "",
        to_location: to_location,
        vehicle_no: editData.vehicle_no || "",
        vehicle_id: editData.vehicle_id || "",
        driver_name: editData.driver_name || "",
        driver_id: editData.driver_id || "",
        table_details: editData.table_details || [],
    
      });
      if (editData.table_details) {
        let details = editData.table_details;
        if (typeof details === "string") {
          try { details = JSON.parse(details); } catch (e) { details = []; }
        }
        const processedDetails = details.map((row, index) => {
          let prodId = row.prod_id || "";
          if (!prodId && row.prod_code && product.length > 0) {
            const matchingProduct = product.find((p) => p.prod_code === row.prod_code);
            prodId = matchingProduct ? matchingProduct.prod_id : "";
          }
          return {
            sr_no: index + 1, cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "",
            prod_code: row.prod_code || "", prod_id: prodId, type: row.type || "Empty",
            tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "",
            level: row.level ?? row.note ?? "", note: row.level ?? row.note ?? ""
          };
        });
        settable_details(processedDetails);
      }
    }
  }, [editData, depot, customer, supplier, unit_id, product]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    let updatedFields = { [name]: value };
    if (name === "entry_date") {
      updatedFields.entry_date = formatDateForAPI(value);
      const selectedDate = dayjs(value);
      if (selectedDate.isValid()) {
        const month = selectedDate.month(), year = selectedDate.year();
        updatedFields.fin_year = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
      }
    } else if (name === "from_customer_id") {
      const sel = customer.find((c) => c.cust_id === value);
      updatedFields.from_customer = sel ? sel.cust_name : "";
      emptycolectionlistSerives
        .getCustomerCylinder(value)
        .then((res) => { setCylinder(Array.isArray(res) ? res : []); })
        .catch(() => { setCylinder([]); });
    } else if (name === "driver_id") {
      const sel = driver.find((d) => d.driver_id === value);
      updatedFields.driver_name = sel ? sel.driver_name : "";
    } else if (name === "vehicle_id") {
      const sel = vehicle.find((v) => v.vehicle_id === value);
      updatedFields.vehicle_no = sel ? sel.vehicle_no : "";
    }
    setData((prevData) => ({ ...prevData, ...updatedFields }));
  };

  const [table_details, settable_details] = useState(() => {
    if (editData && editData.table_details) {
      try {
        const parsedDetails = JSON.parse(editData.table_details);
        return parsedDetails.map((row, index) => ({
          sr_no: index + 1, cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "",
          prod_code: row.prod_code || "", prod_id: row.prod_id || "", type: row.type || "Empty",
          tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "",
          level: row.level ?? row.note ?? "", note: row.level ?? row.note ?? ""
        }));
      } catch (error) { return []; }
    }
    return [];
  });

const availableCylinders = React.useMemo(
  () => cylinder.filter((c) => !table_details.some((row) => row.cyl_no === c.cylinder_no)),
  [cylinder, table_details]
);

  const getProdIdByCode = (prodCode) => {
    if (!prodCode || product.length === 0) return "";
    const matchingProduct = product.find((p) => p.prod_code === prodCode);
    return matchingProduct ? matchingProduct.prod_id : "";
  };

  const handleChangeInput = (e, index) => {
    const { name, value } = e.target;
    const updatedArray = [...table_details];
    const row = updatedArray[index];
    if (name === "cyl_no") {
      row.cyl_no = value;
      const selectedCyl = cylinder.find((c) => c.cylinder_no === value);
      if (selectedCyl) {
        row.cyl_id = selectedCyl.cyl_id || "";
        row.prod_code = selectedCyl.prod_code || "";
        row.prod_id = getProdIdByCode(selectedCyl.prod_code);
        row.tag_no = selectedCyl.tag_no || "";
        row.owner = selectedCyl.owner || "";
        row.note = "";
      } else {
        row.cyl_id = ""; row.prod_code = ""; row.prod_id = ""; row.tag_no = ""; row.owner = ""; row.note = "";
      }
    } else { row[name] = value; }
    updatedArray[index] = row;
    settable_details(updatedArray);
  };

 const [isSubmitting, setIsSubmitting] = useState(false);
 const [fieldErrors, setFieldErrors] = useState({});

 const [challanFile, setChallanFile] = useState(null);

const handleChallanFile = (e) => {
  const file = e.target.files?.[0];
  e.target.value = "";
  if (!file) return;
  const allowed = ["application/pdf", "image/jpeg", "image/png"];
  if (!allowed.includes(file.type)) {
    showError("Only PDF, JPG or PNG file allowed");
    return;
  }
  if (file.size > 5 * 1024 * 1024) {
    showError("File size must be under 5MB");
    return;
  }
  setChallanFile(file);
};

const onSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    if (!formData.prod_code) {
      showError("Please select a Product Code before saving");
      return;
    }

    const customerMissing = !data.from_customer_id;
    const driverMissing = !data.driver_name?.toString().trim();
    const vehicleMissing = !data.vehicle_no?.toString().trim();

    if (customerMissing || driverMissing || vehicleMissing) {
      setFieldErrors({
        from_customer_id: customerMissing,
        driver_name: driverMissing,
        vehicle_no: vehicleMissing,
      });
      showError("Please select Customer");
      return;
    }
    setFieldErrors({});

    setIsSubmitting(true);

    // Pehle jo naye cylinders (bina cyl_id ke) hain unhe DB mein create karo
    // let resolvedRows;
    // try {
    //   resolvedRows = await Promise.all(
    //     table_details.map(async (row) => {
    //       if (row.isNewCylinder && !row.cyl_id) {
    //         const res = await emptycolectionlistSerives.addNewCylinder({
    //           cyl_no: row.cyl_no,
    //           tag_no: row.tag_no,
    //           owner: row.owner,
    //           prod_code: row.prod_code || "",
    //           prod_id: row.prod_id || null,
    //           type: row.type,
    //           note: row.level ?? row.note ?? null,
    //           created_by: String(userInfo.user_id),
    //         });
    //         return { ...row, cyl_id: res.id || "" };
    //       }
    //       return row;
    //     })
    //   );
    //  } catch (error) {
    //   showError(` ${error.message}`);
    //   setIsSubmitting(false);
    //   return;
    // }
const resolvedRows = table_details;
    const cylinders = resolvedRows.map((row) => ({
      sr_no: row.sr_no, cyl_no: row.cyl_no || "", cyl_id: row.cyl_id || "",
      tag_no: row.tag_no || "", owner: row.owner || "", prod_code: row.prod_code || "",
      prod_id: row.prod_id || "", type: row.type || "Empty", remark: row.remark || "",
      level: row.level ?? row.note ?? "", note: row.level ?? row.note ?? ""
    }));
    const dcData = {
      entryDate: formatDateForAPI(data.entry_date) || formatDateForAPI(new Date()),
      from_customer_id: data.from_customer_id || null,
      to_depot_id: data.to_depot_id || null,
      to_supplier_id: data.to_supplier_id || null,
     
   
driver_name: data.driver_name || data.unregistered_driver || '',
vehicle_no: data.vehicle_no || data.unregistered_vehicle || '',
created_by: editData ? String(editData.created_by) : String(userInfo.user_id),
      short_code: short_code || "",
      fin_year: data.fin_year || (dayjs(data.entry_date).month() >= 3
        ? `${dayjs(data.entry_date).year()}-${dayjs(data.entry_date).year() + 1}`
        : `${dayjs(data.entry_date).year() - 1}-${dayjs(data.entry_date).year()}`),
      cylinders,
   
          to_location: dcType || null,
      ...(challanFile && { upload_receipt: challanFile }),
    };
    try {
      if (editData) {
        await emptycolectionlistSerives.editDeleteEmptyCollection(dcData);
         showSuccess("Updated successfully")
      } else {
        await emptycolectionlistSerives.addEmptyCylinder(dcData);
      showSuccess("Added successfully")
      }
      setTimeout(() => navigate(-1), 1000);
    } catch (error) {
     showError(`Error occurred during submission: ${error.message}`);
     setIsSubmitting(false);
    }
  };
  // ── Search Dialog ──
const [formData, setFormData] = useState({ cyl_no: "", cyl_id: "", tag_no: "",  owner: "TGPL", prod_id: "", prod_code: "", type: "Empty", note: "" });

  const handleOpenSearchDialog = () => setOpenSearchDialog(true);
 const handleCloseSearchDialog = () => {
    setOpenSearchDialog(false);
    setFormData((prev) => ({
      cyl_no: "", cyl_id: "", tag_no: "", owner: "TGPL",
      prod_id: prev.prod_id, prod_code: prev.prod_code,
      type: "Empty", note: ""
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleCylinderSelect = (event, newValue) => {
  if (newValue && typeof newValue === "object") {
    setFormData((prev) => ({
      ...prev, cyl_no: newValue.cylinder_no || "", cyl_id: newValue.cyl_id || "",
      tag_no: newValue.tag_no || "", owner: newValue.owner || "",
      // Product Code hamesha DA001 (ya jo pehle se select tha) rehna chahiye,
      // cylinder ke apne prod_code se overwrite nahi karna
      prod_code: prev.prod_code || "", prod_id: prev.prod_id,
      type: newValue.status || "Empty", note: ""
    }));
  } else if (typeof newValue === "string") {
    // Naya cylinder type kiya — cyl_id blank, baaki fields user bharega
    setFormData((prev) => ({ ...prev, cyl_no: newValue, cyl_id: "", tag_no: "", owner: "", prod_code: prev.prod_code || "", prod_id: prev.prod_id }));
  } else {
     setFormData((prev) => ({ ...prev, cyl_no: "", cyl_id: "", prod_code: prev.prod_code || "", prod_id: prev.prod_id, type: "Empty", note: "" }));
  }
};

const handleSearchSubmit = async () => {
  if (!formData.cyl_no) return;

  // ── Duplicate check: same Cylinder No ya same Tag No already table mein hai ──
  const isDuplicate = table_details.some(
    (row) =>
      row.cyl_no?.toLowerCase().trim() === formData.cyl_no?.toLowerCase().trim() ||
      (formData.tag_no && row.tag_no?.toLowerCase().trim() === formData.tag_no?.toLowerCase().trim())
  );
  if (isDuplicate) {
    showError(`Cylinder No "${formData.cyl_no}" or Tag No "${formData.tag_no}" is already added to the list`);
    return;
  }

  if (!formData.cyl_id) {
    // Naya cylinder — abhi sirf list mein add karo, DB mein Save button pe hi banega
    if (!formData.tag_no || !formData.owner) {
     showError("Please fill Tag No and Owner for the new cylinder");
      return;
    }

     // DB-wide check — kya ye cyl_no/tag_no kahi bhi already exist karta hai
   const existsCheck = await emptycolectionlistSerives.checkCylExists(formData.cyl_no, formData.tag_no);
   if (existsCheck.exists) {
     showError(
       `Cylinder No "${existsCheck.cylinder_no}" / Tag "${existsCheck.tag_no}" already exists in the system ` +
       `(currently at: ${existsCheck.current_location || 'unknown'}).`
    );
     return;
   }
    settable_details((prev) => [...prev, {
      sr_no: prev.length + 1, cyl_no: formData.cyl_no,
      cyl_id: "", tag_no: formData.tag_no,
      owner: formData.owner, prod_code: formData.prod_code,
      prod_id: formData.prod_id, type: formData.type,
      remark: "", note: formData.note || "",
      isNewCylinder: true,   // ← flag: onSubmit ke waqt yeh create hoga
    }]);
    handleCloseSearchDialog();
    return;
  }

  // Existing cylinder
  settable_details((prev) => [...prev, {
    sr_no: prev.length + 1, cyl_no: formData.cyl_no, cyl_id: formData.cyl_id,
    tag_no: formData.tag_no, owner: formData.owner, prod_code: formData.prod_code,
    prod_id: formData.prod_id, type: formData.type, remark: "", note: formData.note || ""
  }]);
  handleCloseSearchDialog();
};

  // ── Add Cylinder Dialog ──
  const [addFormData, setAddFormData] = useState({
    cyl_no: "", tag_no: "", owner: "", prod_code: "", prod_id: "", type: "Empty", note: ""
  });

  const handleOpenAddDialog = () => setOpenAddDialog(true);
  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
    setAddFormData({ cyl_no: "", tag_no: "", owner: "", prod_code: "", prod_id: "", type: "Empty", note: "" });
  };

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddCylinderSubmit = async () => {
      console.log('addFormData:', addFormData); // ✅ add karo
    if (!addFormData.cyl_no || !addFormData.tag_no || !addFormData.owner || !addFormData.type) {
showError("Cylinder No, Tag No, Owner and Status are required");
      return;
    }
  //   try {
  //      console.log('API call ho rahi hai...');
  //     const res = await emptycolectionlistSerives.addNewCylinder({
  //       cyl_no: addFormData.cyl_no,
  //       tag_no: addFormData.tag_no,
  //       owner: addFormData.owner,
  //       prod_code: addFormData.prod_code,
  //       prod_id: addFormData.prod_id || 123,
  //       type: addFormData.type,
  //       note: addFormData.note || null,
  //       created_by: String(userInfo.user_id),
  //     });
  //     settable_details((prev) => [...prev, {
  //       sr_no: prev.length + 1, cyl_no: addFormData.cyl_no,
  //       cyl_id: res.id || "", tag_no: addFormData.tag_no,
  //       owner: addFormData.owner, prod_code: addFormData.prod_code,
  //       prod_id: addFormData.prod_id, type: addFormData.type,
  //       remark: "", note: addFormData.note || ""
  //     }]);
  // //  showSuccess("Cylinder added successfully");
  //     handleCloseAddDialog();
  //   } catch (error) {
  //       console.log('error:', error.message);
  //      showError(error.message);
  //   }
  const isDuplicateLocal = table_details.some(
     (row) =>
       row.cyl_no?.toLowerCase().trim() === addFormData.cyl_no?.toLowerCase().trim() ||
       (addFormData.tag_no && row.tag_no?.toLowerCase().trim() === addFormData.tag_no?.toLowerCase().trim())
   );
   if (isDuplicateLocal) {
     showError(`Cylinder No "${addFormData.cyl_no}" or Tag No "${addFormData.tag_no}" is already added to the list`);
     return;
   }

   settable_details((prev) => [...prev, {
     sr_no: prev.length + 1, cyl_no: addFormData.cyl_no,
     cyl_id: "", tag_no: addFormData.tag_no,
     owner: addFormData.owner, prod_code: addFormData.prod_code,
     prod_id: addFormData.prod_id, type: addFormData.type,
     remark: "", note: addFormData.note || "",
     isNewCylinder: true,
   }]);
   handleCloseAddDialog();
  };

  const handleRemoveCylinder = (index) => {
    const updatedArray = table_details.filter((_, i) => i !== index);
    settable_details(updatedArray.map((row, i) => ({ ...row, sr_no: i + 1 })));
  };

  const handleCheckboxChange = (event) => {
    setCheckboxValue(event.target.checked ? 1 : 0);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Collection</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <Inventory2Icon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} EMPTY COLLECTION
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form onSubmit={onSubmit}>

          {/* ── Section 1: Collection Details ── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <Inventory2Icon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>Collection Details</Typography>
            </Box>

            <Box sx={formBodySx}>
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* LEFT COLUMN */}
                <Grid item xs={12} md={6} sx={{ p: 2.5, borderBottom: { xs: "2px dashed #CBD5E0", md: "none" } }}>
                  <Grid container spacing={1.5}>

                    {/* Customer */}
                   <Grid item xs={12} sm={5}>
  <Typography sx={fieldLabelSx}>Customer <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <Autocomplete
    disablePortal options={customer || []}
    getOptionLabel={(option) => option.cust_name || ""}
    value={customer.find((c) => c.cust_id === data.from_customer_id) || null}
    onChange={(event, newValue) => {
      handleChange({ target: { name: "from_customer_id", value: newValue ? newValue.cust_id : "" } });
      setFieldErrors((prev) => ({ ...prev, from_customer_id: false }));
    }}
    isOptionEqualToValue={(option, value) => option.cust_id === value.cust_id}
    renderOption={(props, option) => (
      <MenuItem {...props} sx={menuItemSx}>{option.cust_name}</MenuItem>
    )}
    renderInput={(params) => (
      <TextField {...params} variant="outlined" size="small" fullWidth
        InputProps={{ ...params.InputProps, sx: { height: "36px" } }}
        sx={inputSx}
        error={!!fieldErrors.from_customer_id}
        helperText={fieldErrors.from_customer_id ? "Customer is required" : ""}
        FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
      />
    )}
    sx={{ width: "100%" }}
  />
</Grid>

                    {/* Driver Name */}
   <Grid item xs={12} sm={5}>
  <Typography sx={fieldLabelSx}>Driver Name <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <Autocomplete
    freeSolo
    disablePortal
    options={driver || []}
    getOptionLabel={(option) =>
      typeof option === "string" ? option : option.driver_name || ""
    }
    value={
      driver.find((d) => d.driver_id === data.driver_id) ||
      data.unregistered_driver ||
      null
    }
    onChange={(event, newValue) => {
      if (newValue && typeof newValue === "object") {
        handleChange({ target: { name: "driver_id", value: newValue.driver_id } });
        handleChange({ target: { name: "driver_name", value: newValue.driver_name } });
        handleChange({ target: { name: "unregistered_driver", value: "" } });
      } else if (typeof newValue === "string") {
        handleChange({ target: { name: "driver_id", value: "" } });
        handleChange({ target: { name: "driver_name", value: newValue } });
        handleChange({ target: { name: "unregistered_driver", value: newValue } });
      } else {
        handleChange({ target: { name: "driver_id", value: "" } });
        handleChange({ target: { name: "driver_name", value: "" } });
        handleChange({ target: { name: "unregistered_driver", value: "" } });
      }
      setFieldErrors((prev) => ({ ...prev, driver_name: false }));
    }}
    onInputChange={(event, inputValue, reason) => {
      if (reason === "input") {
        const matched = driver.find(
          (d) => d.driver_name?.toLowerCase() === inputValue?.toLowerCase()
        );
        if (!matched) {
          handleChange({ target: { name: "driver_id", value: "" } });
          handleChange({ target: { name: "driver_name", value: inputValue } });
          handleChange({ target: { name: "unregistered_driver", value: inputValue } });
        }
        setFieldErrors((prev) => ({ ...prev, driver_name: false }));
      }
    }}
    renderOption={(props, option) => (
      <MenuItem {...props} sx={menuItemSx}>{option.driver_name}</MenuItem>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="outlined"
        size="small"
        fullWidth
        placeholder="Select or type driver name"
        InputProps={{ ...params.InputProps, sx: { height: "36px" } }}
        sx={inputSx}
        error={!!fieldErrors.driver_name}
        helperText={fieldErrors.driver_name ? "Driver Name is required" : ""}
        FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
      />
    )}
    sx={{ width: "100%" }}
  />
</Grid>

                    {/* Vehicle No */}
   <Grid item xs={12} sm={5}>
  <Typography sx={fieldLabelSx}>Vehicle No <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <Autocomplete
    freeSolo
    disablePortal
    options={vehicle || []}
    getOptionLabel={(option) =>
      typeof option === "string" ? option : option.vehicle_no || ""
    }
    value={
      vehicle.find((v) => v.vehicle_id === data.vehicle_id) ||
      data.unregistered_vehicle ||
      null
    }
    onChange={(event, newValue) => {
      if (newValue && typeof newValue === "object") {
        handleChange({ target: { name: "vehicle_id", value: newValue.vehicle_id } });
        handleChange({ target: { name: "vehicle_no", value: newValue.vehicle_no } });
        handleChange({ target: { name: "unregistered_vehicle", value: "" } });
      } else if (typeof newValue === "string") {
        handleChange({ target: { name: "vehicle_id", value: "" } });
        handleChange({ target: { name: "vehicle_no", value: newValue } });
        handleChange({ target: { name: "unregistered_vehicle", value: newValue } });
      } else {
        handleChange({ target: { name: "vehicle_id", value: "" } });
        handleChange({ target: { name: "vehicle_no", value: "" } });
        handleChange({ target: { name: "unregistered_vehicle", value: "" } });
      }
      setFieldErrors((prev) => ({ ...prev, vehicle_no: false }));
    }}
    onInputChange={(event, inputValue, reason) => {
      if (reason === "input") {
        const matched = vehicle.find(
          (v) => v.vehicle_no?.toLowerCase() === inputValue?.toLowerCase()
        );
        if (!matched) {
          handleChange({ target: { name: "vehicle_id", value: "" } });
          handleChange({ target: { name: "vehicle_no", value: inputValue } });
          handleChange({ target: { name: "unregistered_vehicle", value: inputValue } });
        }
        setFieldErrors((prev) => ({ ...prev, vehicle_no: false }));
      }
    }}
    renderOption={(props, option) => (
      <MenuItem {...props} sx={menuItemSx}>{option.vehicle_no}</MenuItem>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="outlined"
        size="small"
        fullWidth
        placeholder="Select or type vehicle no"
        InputProps={{ ...params.InputProps, sx: { height: "36px" } }}
        sx={inputSx}
        error={!!fieldErrors.vehicle_no}
        helperText={fieldErrors.vehicle_no ? "Vehicle No is required" : ""}
        FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
      />
    )}
    sx={{ width: "100%" }}
  />
</Grid>


  <Grid item xs={12} sm={5}>
  <Typography sx={fieldLabelSx}>Product Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
                <TextField select name="prod_code" value={formData.prod_code || ""}
                  onChange={(e) => {
                    const selectedProduct = product.find((p) => p.prod_code === e.target.value);
                    setFormData((prev) => ({
                      ...prev,
                      prod_code: e.target.value,
                      prod_id: selectedProduct ? selectedProduct.prod_id : "",
                    }));
                  }}
                  variant="outlined" size="small" fullWidth sx={inputSx}>
                  {product.map((p) => (
                    <MenuItem key={p.prod_id} value={p.prod_code} sx={menuItemSx}>{p.prod_code}</MenuItem>
                  ))}
                </TextField>
              </Grid>

                  </Grid>
                </Grid>

                {/* RIGHT COLUMN */}
                <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
                  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0 }}>
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={fieldLabelSx}>Entry No</Typography>
                      <TextField
                        size="small" fullWidth name="entry_no" value={data.entry_no}
                        sx={readOnlyInputSx} InputProps={{ readOnly: true }}
                        placeholder="Auto-generated"
                      />
                    </Box>
                    <Box sx={{ mx: 2, mt: "22px" }} />
                    <Box sx={{ flex: 1 }}>
                      <Typography sx={fieldLabelSx}>
                        Entry Date <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={data.entry_date ? dayjs(data.entry_date) : null}
                        onChange={(newValue) =>
                          handleChange({ target: { name: "entry_date", value: newValue ? newValue.toDate() : "" } })
                        }
                        slotProps={{
                          textField: { size: "small", fullWidth: true, required: true, sx: inputSx },
                        }}
                      />
                    </Box>
                    
                  </Box>
                  {/* Upload Challan */}
<Box sx={{ mt: 2 }}>
  <Typography sx={fieldLabelSx}>
    Upload Challan <span style={{ color: "#718096", fontWeight: 400 }}>(PDF / JPG / PNG)</span>
  </Typography>
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <Button
      component="label"
      startIcon={<UploadFileIcon sx={{ fontSize: 18 }} />}
      sx={{
        height: "36px", px: 2, textTransform: "none", fontSize: "13px", fontWeight: 600,
        color: "#2B6CB0", border: "1.5px solid #2B6CB0", borderRadius: "8px", background: "#fff",
        "&:hover": { background: "#E6F1FB" },
      }}
    >
      Choose File
      <input
        type="file"
        hidden
        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
        onChange={handleChallanFile}
      />
    </Button>
    <Typography sx={{ fontSize: "12px", color: "#4A5568", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
      {challanFile ? challanFile.name : "No file chosen"}
    </Typography>
    {challanFile && (
      <IconButton size="small" onClick={() => setChallanFile(null)}>
        <CloseIcon sx={{ fontSize: 16, color: "#E53E3E" }} />
      </IconButton>
    )}
  </Box>
</Box>
                </Grid>

              </Grid>
            </Box>
          </Box>

          {/* ── Buttons Row ── */}
          <Box sx={{ display: "flex", gap: 2, mb: 1.5 }}>
            <Button onClick={handleOpenSearchDialog} sx={addCylBtnSx}>
              <AddIcon sx={{ fontSize: 18 }} />
              Add / Search Cylinders
            </Button>
            {/* <Button onClick={handleOpenAddDialog} sx={{ ...addCylBtnSx, background: "#276749", "&:hover": { background: "#1e4f36" } }}>
              <AddIcon sx={{ fontSize: 18 }} />
              Add Cylinder
            </Button> */}
          </Box>

          {/* ── Section 2: Cylinder Details Table ── */}
          <Box sx={formCardSx}>
            <Paper sx={{ width: "100%", boxShadow: "none" }}>
              <TableContainer component={Paper} sx={{ boxShadow: "none", borderRadius: 0 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {["Sr No", "Cylinder No", "Tag No", "Owner","Status", "Remark",   "Action"].map((h, i) => (
                        <StyledTableCell key={i} align={i === 0 ? "center" : "left"} sx={tableHeadCellSx}>{h}</StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: "#fff" }}>
                    {table_details && table_details.length > 0 ? (
                      table_details.map((row, index) => (
                        <StyledTableRow key={index} sx={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC" }}>
                          <StyledTableCell align="center" sx={{ fontSize: "12px" }}>{row.sr_no}</StyledTableCell>
                          {["cyl_no", "tag_no", "owner",  "type", "note"].map((name) => (
                            <StyledTableCell key={name} align="left">
                              <CTSinput fullWidth size="small" variant="standard" name={name}
                                value={row[name]}
                                onChange={(e) => handleChangeInput(e, index)}
                                sx={tableCellInputSx}
                                InputProps={{
                                  disableUnderline: true,
                                  readOnly: name === "prod_code" || name === "type",
                                  style: { border: "none", backgroundColor: "transparent", boxShadow: "none" }
                                }}
                              />
                            </StyledTableCell>
                          ))}
                          <StyledTableCell align="center">
                            <IconButton size="small" onClick={() => handleRemoveCylinder(index)}>
                              <DeleteForeverIcon sx={{ fontSize: "18px", color: "#E53E3E" }} />
                            </IconButton>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={8} align="center" sx={{ color: "#718096", py: 3, fontSize: "12px" }}>
                          No cylinders selected — click "Search Cylinders" or "Add Cylinder" to add
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {editData && (
              <Box sx={{ px: 3, pt: 2 }}>
                <FormControlLabel
                  control={<Checkbox checked={checkboxValue === 1} onChange={handleCheckboxChange} color="primary" sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} />}
                  label={<Typography sx={{ fontSize: "13px", fontWeight: 600 }}>Confirm Status Update</Typography>}
                />
              </Box>
            )}

            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
               <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>

        </form>

        {/* ── Search Cylinder Dialog ── */}
        <Dialog open={openSearchDialog} onClose={handleCloseSearchDialog} maxWidth="lg" fullWidth
          PaperProps={{ sx: { borderRadius: "14px", height: "400px", width:'800px' } }}>
          <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontSize: "14px", fontWeight: 700, py: 1.5 }}>
           Add / Search Cylinders
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              <Grid item xs={12} sm={6} md={2.4}>
                <Typography sx={fieldLabelSx}>Cylinder No</Typography>
             <Autocomplete freeSolo disablePortal options={availableCylinders || []}
  getOptionLabel={(option) => typeof option === "string" ? option : option.cylinder_no || ""}
  value={cylinder.find((c) => c.cylinder_no === formData.cyl_no) || formData.cyl_no || null}
  onChange={handleCylinderSelect}
 onInputChange={(event, inputValue, reason) => {
    if (reason === "input" && inputValue) {
      const matched = cylinder.find((c) => c.cylinder_no === inputValue);
      if (!matched) setFormData(prev => ({ ...prev, cyl_no: inputValue, cyl_id: "" }));
    }
  }}
  renderOption={(props, option) => (
    <MenuItem {...props} sx={menuItemSx}>{option.cylinder_no}</MenuItem>
  )}
  renderInput={(params) => (
    <TextField {...params} variant="outlined" size="small" fullWidth sx={inputSx} />
  )}
/>
              </Grid>
              <Grid item xs={12} sm={6} md={2.4}>
                <Typography sx={fieldLabelSx}>Tag No</Typography>
                <TextField name="tag_no" value={formData.tag_no} onChange={handleInputChange}
                  variant="outlined" size="small" fullWidth sx={inputSx} InputProps={{ readOnly: !!formData.cyl_id }} />
              </Grid>
             <Grid item xs={12} sm={6} md={2.4}>
                <Typography sx={fieldLabelSx}>Owner</Typography>
                <TextField select name="owner" value={formData.owner} onChange={handleInputChange} variant="outlined" size="small" fullWidth sx={inputSx}>
                  <MenuItem value="TGPL" sx={menuItemSx}>TGPL</MenuItem>
                  <MenuItem value="CUSTOMER" sx={menuItemSx}>CUSTOMER</MenuItem>
                </TextField>
              </Grid>
              {/* <Grid item xs={12} sm={6} md={2.4}>
                <Typography sx={fieldLabelSx}>Product Code</Typography>
                <TextField name="prod_code" value={formData.prod_code} onChange={handleInputChange}
                  variant="outlined" size="small" fullWidth sx={readOnlyInputSx} InputProps={{ readOnly: true }} />
              </Grid> */}
              <Grid item xs={12} sm={6} md={2.4}>
                <Typography sx={fieldLabelSx}>Status</Typography>
                <TextField select name="type" value={formData.type} onChange={handleInputChange}
                  variant="outlined" size="small" fullWidth sx={inputSx}>
                  <MenuItem value="Empty" sx={menuItemSx}>Empty</MenuItem>
                  <MenuItem value="Full" sx={menuItemSx}>Full</MenuItem>
                </TextField>
              </Grid>
              {formData.type === "Full" && (
                <Grid item xs={12} sm={6} md={2.4}>
                  <Typography sx={fieldLabelSx}>Remark</Typography>
                  <TextField select name="note" value={formData.note} onChange={handleInputChange}
                    variant="outlined" size="small" fullWidth sx={inputSx}>
                    <MenuItem value="TOPUP" sx={menuItemSx}>TOPUP</MenuItem>
                    <MenuItem value="SALESRETURN" sx={menuItemSx}>SALES RETURN</MenuItem>
                    <MenuItem value="REJECTION" sx={menuItemSx}>REJECTION</MenuItem>
                    <MenuItem value="LEAKAGE" sx={menuItemSx}>LEAKAGE</MenuItem>
                  </TextField>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseSearchDialog} sx={cancelBtnSx}>Cancel</Button>
            <Button onClick={handleSearchSubmit} sx={saveBtnSx}>
              <SaveIcon sx={{ fontSize: 16 }} /> OK
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Add Cylinder Dialog ── */}
        {/* <Dialog open={openAddDialog} onClose={handleCloseAddDialog} maxWidth="md" fullWidth
          PaperProps={{ sx: { borderRadius: "14px" } }}>
          <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontSize: "14px", fontWeight: 700, py: 1.5 ,}}>
            Add New Cylinder
          </DialogTitle>
          <DialogContent sx={{ pt: 2,width:800, }}>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              <Grid item xs={12} sm={6} md={3}>
                <Typography sx={fieldLabelSx}>Cylinder No <span style={{ color: "#E53E3E" }}>*</span></Typography>
                <TextField name="cyl_no" value={addFormData.cyl_no} onChange={handleAddInputChange}
                  variant="outlined" size="small" fullWidth sx={inputSx} />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography sx={fieldLabelSx}>Tag No <span style={{ color: "#E53E3E" }}>*</span></Typography>
                <TextField name="tag_no" value={addFormData.tag_no} onChange={handleAddInputChange}
                  variant="outlined" size="small" fullWidth sx={inputSx} />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography sx={fieldLabelSx}>Owner <span style={{ color: "#E53E3E" }}>*</span></Typography>
              <TextField select name="owner" value={addFormData.owner} onChange={handleAddInputChange}
  variant="outlined" size="small" fullWidth sx={inputSx}>
  <MenuItem value="TGPL" sx={menuItemSx}>TGPL</MenuItem>
  <MenuItem value="Customer" sx={menuItemSx}>Customer</MenuItem>
</TextField>
              </Grid>
             
              <Grid item xs={12} sm={6} md={3}>
                <Typography sx={fieldLabelSx}>Status <span style={{ color: "#E53E3E" }}>*</span></Typography>
                <TextField select name="type" value={addFormData.type} onChange={handleAddInputChange}
                  variant="outlined" size="small" fullWidth sx={inputSx}>
                  <MenuItem value="Empty" sx={menuItemSx}>Empty</MenuItem>
                  <MenuItem value="Full" sx={menuItemSx}>Full</MenuItem>
                </TextField>
              </Grid>
              {addFormData.type === "Full" && (
                <Grid item xs={12} sm={6} md={3}>
                  <Typography sx={fieldLabelSx}>Remark</Typography>
                  <TextField select name="note" value={addFormData.note} onChange={handleAddInputChange}
                    variant="outlined" size="small" fullWidth sx={inputSx}>
                    <MenuItem value="TOPUP" sx={menuItemSx}>TOPUP</MenuItem>
                    <MenuItem value="SALESRETURN" sx={menuItemSx}>SALES RETURN</MenuItem>
                    <MenuItem value="REJECTION" sx={menuItemSx}>REJECTION</MenuItem>
                    <MenuItem value="LEAKAGE" sx={menuItemSx}>LEAKAGE</MenuItem>
                  </TextField>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseAddDialog} sx={cancelBtnSx}>Cancel</Button>
            <Button onClick={handleAddCylinderSubmit} sx={saveBtnSx}>
              <SaveIcon sx={{ fontSize: 16 }} /> Save
            </Button>
          </DialogActions>
        </Dialog> */}

     <Snackbar
  open={snack.open}
  autoHideDuration={3000}
  onClose={() => setSnack({ ...snack, open: false })}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
>
  <Alert
    onClose={() => setSnack({ ...snack, open: false })}
    severity={snack.severity}
    
    sx={{ width: "100%" }}
  >
    {snack.message}
  </Alert>
</Snackbar>
        
      </Box>
    </LocalizationProvider>
  );
};

export default AddEmptyCollection;